// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require("./import-" + process.env.NODE_ENV);
const routes = [
  {
    path: "/",
    name: "index",
    component: _import("Home"),
  },
  // 会员风采列表
  {
    path: "/memberInfo",
    name: "memberInfo",
    component: _import("MemberInfo/index"),
  },
  // 会员风采详情
  {
    path: "/memberInfoDetails",
    name: "memberInfoDetails",
    component: _import("MemberInfo/details"),
  },
  // 通知公告列表
  {
    path: "/announcement",
    name: "announcement",
    component: _import("Announcement/index"),
  },
  // 通知公告详情
  {
    path: "/announcementDetails",
    name: "announcementDetails",
    component: _import("Announcement/details"),
  },
  // 行业人才列表
  {
    path: "/professional",
    name: "professional",
    component: _import("Professional/index"),
  },
  // 行业人才详情
  {
    path: "/professionalDetails",
    name: "professionalDetails",
    component: _import("Professional/details"),
  },
  // 资源共享列表
  {
    path: "/resourceSharing",
    name: "resourceSharing",
    component: _import("ResourceSharing/index"),
  },
  // 资源共享详情
  {
    path: "/resourceSharingDetails",
    name: "resourceSharingDetails",
    component: _import("ResourceSharing/details"),
  },
  // 专业委员会列表
  {
    path: "/committee",
    name: "committee",
    component: _import("Committee/index"),
  },
  // 专业委员会详情
  {
    path: "/committeeDetails",
    name: "committeeDetails",
    component: _import("Committee/details"),
  },
  // 行业动态列表
  {
    path: "/industryNews",
    name: "industryNews",
    component: _import("IndustryNews/index"),
  },
  // 行业动态详情
  {
    path: "/industryNewsDetails",
    name: "industryNewsDetails",
    component: _import("IndustryNews/details"),
  },
  {
    path: "/company",
    name: "company",
    component: _import("Company"),
  },
  {
    path: "*",
    redirect: "/",
  },
];
module.exports = routes;
